const paidInFullLanguageReducer = (state = 'Paid in Full', action) => {
	switch(action.type){
	case 'PAIDINFULLLANGUAGEUPDATE':	
		return action.payload;
	default:
		return state;
	}
}

export default paidInFullLanguageReducer;